


import { Candidate } from '@/models';
import { API_URL, FetchApi } from './service';
import { USERS_API_URL } from './UserServices';


const URI = `${API_URL}/core/candidates/`;



export const CandidateServices = {


  create: (data: Partial<Candidate>) =>
    FetchApi.postFile(`${URI}`, data),

  // Create candidate with files via FormData
  createWithFiles: (formData: FormData) =>
    FetchApi.postFile(`${URI}`, formData),

  get: (id: number) =>
    FetchApi.get(`${URI}${id}/`),




  list: (params?: any) =>
    FetchApi.get(`${URI}?${new URLSearchParams(params).toString()}`),
  
  
  pendings: (params?: any) =>
    FetchApi.get(`${URI}pendings/?${new URLSearchParams(params).toString()}`),
  verified: (params?: any) =>
    FetchApi.get(`${URI}verified/?${new URLSearchParams(params).toString()}`),
  
  preselected: (params?: any) =>
    FetchApi.get(`${URI}preselected/?${new URLSearchParams(params).toString()}`),



  newCandidate: (params?: any) =>
    FetchApi.get(`${URI}new-folders/?${new URLSearchParams(params).toString()}`),

  update: (id: number, data: Partial<Candidate>) =>
    FetchApi.putFile(`${URI}${id}/`, data),

  // Update candidate with files via FormData
  updateWithFiles: (id: number, formData: FormData) =>
    FetchApi.putFile(`${URI}${id}/`, formData),


  save_verification: (id: number, formData: FormData) => {
    // Log pour debug (optionnel)
    if (formData instanceof FormData) {
      console.log('📤 Envoi save_verification avec FormData');
      for (const [key, value] of formData.entries()) {
        console.log(`  ${key}:`, typeof value === 'string' ? value.substring(0, 100) : value);
      }
    }

    return FetchApi.putFile(`${URI}${id}/save-verification/`, formData)
  },

  complete_verification: (id: number, formData: FormData) =>
    FetchApi.putFile(`${URI}${id}/complete-verification/`, formData),


  process_file: (id: number, formData: {scope: string}) =>
    FetchApi.post(`${URI}${id}/process-files/`, formData),

  askDocuments: (id: number, data: any) =>
    FetchApi.put(`${URI}${id}/ask-documents/`, data),


  verify: (id: number, data: any) =>
    FetchApi.put(`${URI}${id}/complete-verification/`, data),

  reject: (id: number, data: Partial<FormData>) =>
    FetchApi.put(`${URI}${id}/reject/`, data),

  delete: (id: number) =>
    FetchApi.delete(`${URI}${id}/`),

  getUserFolder: () =>
    FetchApi.get(`${USERS_API_URL}folder/`),

  // Recevability endpoints
  verify_recevability: (id: number, data: any) =>
    FetchApi.post(`${URI}${id}/verify-recevability/`, data),

  request_complements: (id: number, data: any) =>
    FetchApi.post(`${URI}${id}/request-complements/`, data),

  auto_check_recevability: (id: number) =>
    FetchApi.post(`${URI}${id}/auto-check-recevability/`, {}),

  /**
   * Auto-fill form from existing uploaded documents for a candidate
   *
   * POST /candidates/{id}/auto-fill-from-documents/
   *
   * Analyzes existing documents including:
   *   - id-card: Pièce d'identité (CNI)
   *   - payslips: Bulletins de salaire
   *   - bank-statements: Relevés bancaires
   *   - mobile-money-statements: Relevés OM/Wave/Yass
   *   - kbis: Extrait KBIS/Registre de commerce
   *
   * @param candidateId - ID of the candidate
   * @returns Extracted data for auto-filling the form:
   *   - personal_info: { nom, prenoms, date_naissance, etc. }
   *   - financial_info: { salaire_base_net, nom_employeur, etc. }
   *   - extraction_details: extraction metadata and confidence scores
   */
  autoFillFromDocuments: (candidateId: number) =>
    FetchApi.post(`${URI}${candidateId}/auto-fill-from-documents/`, {}),

  /**
   * Auto-fill form from uploaded documents (without existing candidate)
   *
   * POST /candidates/auto-fill-from-uploaded-documents/
   *
   * Analyzes uploaded documents including:
   *   - id_card: Pièce d'identité (CNI)
   *   - payslip: Bulletins de salaire
   *   - bank_statement: Relevés bancaires
   *   - mobile_money: Relevés OM/Wave/Yass
   *   - kbis: Extrait KBIS/Registre de commerce
   *
   * @param formData - FormData with uploaded files
   * @returns Extracted data for auto-filling the form:
   *   - personal_info: { nom, prenoms, date_naissance, etc. }
   *   - financial_info: { salaire_base_net, nom_employeur, etc. }
   *   - extraction_details: extraction metadata and confidence scores
   */
  autoFillFromUploadedDocuments: (formData: FormData) =>
    FetchApi.postFile(`${URI}auto-fill-from-uploaded-documents/`, formData),

};
